/* Drawer open/close. The panel is display:none until opened so the clip-path
   transition has a frame to run from; hence the rAF before adding is-open. */
(function () {
  /* Horizon scrolls .page-wrapper, not the window, so anything that moves
     focus can drag that container with it. Focusing the drawer's close button
     was snapping the page back to the top: you scroll halfway down, open the
     cart, and the page behind the panel jumps to 0. preventScroll stops the
     browser doing it, and the position is restored after in case a browser
     ignores the hint. */
  function scrollHost() {
    return document.querySelector('.page-wrapper') || document.scrollingElement || document.documentElement;
  }

  function open(drawer) {
    var host = scrollHost();
    var keep = host ? host.scrollTop : 0;
    drawer.hidden = false;
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      if (host && host.scrollTop !== keep) host.scrollTop = keep;
    });
    var focusable = drawer.querySelector('[data-up-drawer-close]');
    if (focusable) {
      try {
        focusable.focus({ preventScroll: true });
      } catch (e) {
        focusable.focus();
      }
      if (host && host.scrollTop !== keep) host.scrollTop = keep;
    }
  }

  function close(drawer) {
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    var panel = drawer.querySelector('.up-drawer__panel');
    var done = function () {
      drawer.hidden = true;
      if (panel) panel.removeEventListener('transitionend', done);
    };
    if (panel) {
      panel.addEventListener('transitionend', done);
      // Fallback in case the transition never fires (reduced motion, hidden tab).
      setTimeout(done, 500);
    } else {
      done();
    }
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-up-drawer-open]');
    if (opener) {
      var target = document.getElementById(opener.getAttribute('data-up-drawer-open'));
      if (target) {
        /* The header cart opener is an <a href="/cart"> so it still works
           without JS. Without preventDefault the browser starts navigating
           before anything else cancels it, and that alone resets
           .page-wrapper to the top -- the page behind the drawer jumped. */
        if (opener.tagName === 'A' && opener.getAttribute('href')) event.preventDefault();
        open(target);
        opener.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    var closer = event.target.closest('[data-up-drawer-close]');
    if (closer) {
      var drawer = closer.closest('[data-up-drawer]');
      if (drawer) {
        close(drawer);
        var trigger = document.querySelector('[data-up-drawer-open="' + drawer.id + '"]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      }
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var openDrawer = document.querySelector('[data-up-drawer].is-open');
    if (openDrawer) close(openDrawer);
  });
})();
